//import axios from '@/api/http'
import axios from 'axios';
//import Vue from 'vue'
//import SparkMD5 from 'spark-md5'

export default {

    async uploadFile(file, savePosition) {
        // 文件总大小
        let totalSize = file.size;
        // 分片大小
        let chunkSize = 1048576;
        // 总块数
        let chunkNum = Math.ceil(totalSize / chunkSize);
        let fileName = file.name;
        for (let i = 0; i < chunkNum; i++) {
            let start = i * chunkSize;
            let end = Math.min(start + chunkSize, file.size)
            let chunk = file.raw.slice(start, end)
            let res = await this.uploadChunk(fileName, savePosition, chunk, i, chunkSize, chunkNum, totalSize);
            if (res != null && res.data.status == 1) {
                if (res.data.data == true) {
                    continue
                } else {
                    console.log(res.data);
                }
            }
        }
    },

    async uploadChunk(fileName, saveFolder, chunk, curIndex, chunkSize, chunkSum, fileSize) {
        let formData = new FormData();
        formData.append('saveFolder', saveFolder);
        formData.append('index', curIndex);
        formData.append('fileName', fileName);
        formData.append('chunkSize', chunkSize);
        formData.append('chunkSum', chunkSum);
        formData.append('totalSize', fileSize);
        formData.append('file', chunk, fileName);
        formData.append('realTime', true);
        // let mysession = JSON.parse(sessionStorage.getItem('RecordSessionId'));
        // formData.append('RecordSessionId', mysession);
        return axios.post('/lp-resource-api/lp-resource/cifs/uploadFile', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

}